import { NgFor } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [NgFor],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss'
})
export class PrivacyComponent {
  tocItems = [
    { id: 'information-we-collect', title: 'WHAT INFORMATION DO WE COLLECT?' },
    { id: 'process-your-information', title: 'HOW DO WE PROCESS YOUR INFORMATION?' },
    { id: 'legal-bases', title: 'WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL INFORMATION?' },
    { id: 'share-your-information', title: 'WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?' },
    { id: 'cookies-tracking-technologies', title: 'DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?' },
    { id: 'transferred-internationally', title: 'IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?' },
    { id: 'keep-your-information', title: 'HOW LONG DO WE KEEP YOUR INFORMATION?' },
    { id: 'information-safe', title: 'HOW DO WE KEEP YOUR INFORMATION SAFE?' },
    { id: 'privacy-rights', title: 'WHAT ARE YOUR PRIVACY RIGHTS?' },
    { id: 'do-not-track', title: 'CONTROLS FOR DO-NOT-TRACK FEATURES' },
    { id: 'us-privacy-rights', title: 'DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?' },
    { id: 'other-regions-privacy-rights', title: 'DO OTHER REGIONS HAVE SPECIFIC PRIVACY RIGHTS?' },
    { id: 'updates-to-notice', title: 'DO WE MAKE UPDATES TO THIS NOTICE?' },
    { id: 'contact-us-about-notice', title: 'HOW CAN YOU CONTACT US ABOUT THIS NOTICE?' },
    { id: 'review-update-delete', title: 'HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?' },
    // {id:'data-security',title:'Data Security and Information Handling'},
    // {id:'provisions',title:'Provisions for Privacy Policy'},
    // {id:'explicit-non-nharing',title:'Explicit Non-Sharing of Information'},
    // {id:'opt-out-instructions',title:'Opt-Out Instructions'},
    // {id:'policy-updates',title:'Policy Updates'},
  ];


  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
